
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild  } from '@angular/core';
import { Physician, PhysicianData } from '../../../../@core/interfaces/masters/physician-mst';
import { StateMst, StateData } from '../../../../@core/interfaces/masters/state';
import { DistrictData, DistrictMst } from '../../../../@core/interfaces/masters/district';
import { CountryData, CountryMst } from '../../../../@core/interfaces/masters/country';
import { INgxSelectOption } from 'ngx-select-ex';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FormBuilder, Validators, FormGroup, ValidationErrors } from '@angular/forms';
import { environment } from '../../../../../environments/environment';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';
import { CouncilData, Council } from '../../../../@core/interfaces/masters/council';
import { DepartmentData, Department } from '../../../../@core/interfaces/masters/department';
import { NbDateService, NbTabsetComponent, NbTabComponent, NbStepperComponent } from '@nebular/theme';
import { DatePipe } from '@angular/common';
import * as gender from '../../../../data/gender.json';

import * as jobType from '../../../../data/jobtype.json';

//*** */
import {  AccreditationData,  Accreditation } from '../../../../@core/interfaces/masters/accreditation';
import { QualificationsData, Qualifications } from '../../../../@core/interfaces/masters/qualifications';
import { ActivatedRoute, Router } from '@angular/router';

import { RolesData } from '../../../../@core/interfaces/common/roles';
import { imageatch_det, imageatch_detData } from '../../../../@core/interfaces/masters/imageatch_det';
import { TenantPackageData,TenantPackage } from '../../../../@core/interfaces/masters/tenantpackage';
import { PhysicianqualificationData } from '../../../../@core/interfaces/masters/physicianqualification';
import { PatientRegistrationData } from '../../../../@core/interfaces/patient-services/patient-registration';
import { OtpVerifyDialogComponent } from '../../otp-verify-dialog/otp-verify-dialog.component';

@Component({
  selector: 'ngx-doctor-signup',
  templateUrl: './doctor-signup.component.html',
  styleUrls: ['./doctor-signup.component.scss']
})
export class DoctorSignupComponent implements OnInit {

  genderList: string[]= (gender as any).default;
  jobTypeList:string[]=(jobType as any).default; 
  p: number = 1;  
  
  @ViewChild('otpVerify') otpVerifyInstance: OtpVerifyDialogComponent;
  @ViewChild('stepper') stepperComponentInstance: NbStepperComponent;
  tenandId = environment.patientTenantId;
  branchId = environment.patientBranchId;
  // private tenandId = localStorage.getItem("tenantId");
  // private branchId = localStorage.getItem("branchId");
  protected readonly unsubscribe$ = new Subject<void>();
  data: Physician[];
  phoneNum:any;
  councilList: Council[];
  deptList: Department[];
  isAddComponnet: boolean = false;
  isEditComponnet: boolean = false;
  newPhyData: Physician;
  editPhyData: Physician;
  editPhyDetails: Physician;
  term: string;
  physicianForm: FormGroup;
  countriesList: CountryMst[];
  statesList: StateMst[];
  loadstatesList: StateMst[];
  districtsList: DistrictMst[];
  loadDistrictsList: DistrictMst[];
  imgFile: File;
  imgURL: string | ArrayBuffer;
  max: Date;
  placeholder: string = "Select";
  allowClear: any = true;
  multiple: boolean = false;
  isSubmitted: boolean = false;
  isBtnSubmitted: boolean = false;
  referralSettings: boolean = false;
  physicianId:any;
  fromPageNameReferralSettings:string;
  dataList:Physician;
  doctorName:string;
  closeMyPopup:boolean=false;
  valueSet:string="Dr. ";
  skip:any=0;
  take:any=100;
  isAlreadyRegistered: boolean =false;  

  @ViewChild("tabSetRef") tabsetEl: NbTabsetComponent;

  @Output() diaClose: EventEmitter<any> = new EventEmitter<any>();

    //****
    accreditationList: Accreditation[];
    qualificationsList:Qualifications[];
    validationData:Physician[];

  items = [
    { title: 'Profile', icon: { icon: 'print', pack: 'customIcon'},link:"../forms/buttons", class:"tempclass" },
    { title: 'Logout', icon:"edit-outline",link:"../../forms/buttons" },
  ];
  smsdto={"variables":[],"template_id":"","to":"","service":"T"};

  pageTaskIds: any = [];
  private apiUrl = environment.apiUrl;
  userAccessData: any;
  isView: boolean= true;
  isEdit: boolean= true;
  isCreate: boolean= true;
  isPrint: boolean= true;

  //
  isQueueView: Boolean=true;
  isQueuePrint:Boolean=true;
  isconfirmation:Boolean=false;
  iserror:Boolean=false;
  //Book Appointment
  isBookAppointmentCreate:boolean=true; 
 fileToUpload:any;
 @ViewChild('myInput')
 myInputVariable: ElementRef;
 srcname:any="../.././../../assets/images/userav.png"
 x:any;
 council;
 errorMessage;
 tenantPackageId:any;
 fileset:boolean=true;
  responseData: any;
  otpId: any;
  doctorQualification:any=[];
  constructor(
    protected cd: ChangeDetectorRef, protected patRegSrvc: PatientRegistrationData,
    protected phyqualificationSrvc: PhysicianqualificationData,protected tenantpackageSrvc: TenantPackageData,protected rolesService: RolesData,private router: Router,protected qualifnSrvc: QualificationsData,  private route: ActivatedRoute, protected accredtnSrvc:  AccreditationData,protected phySrvc: PhysicianData, protected councilSrvc: CouncilData, private datePipe: DatePipe, protected deptSrvc: DepartmentData, protected dateService: NbDateService<Date>,
    protected stateSrvc: StateData, protected districtSrvc: DistrictData, private fb: FormBuilder, protected cntrySrvc: CountryData, protected domSanitizer: DomSanitizer,private iatchSrvc: imageatch_detData) {
 
      // this.route.params.subscribe(params => {
      //   this.physicianId = params['physicianId'];
      // });
    this.physicianForm = this.fb.group({ 
      name: this.fb.control("Dr ", [Validators.required, Validators.pattern('[^0-9]+$')]),
      globalId: this.fb.control("12345"),
      gender: this.fb.control("Male", [Validators.required, Validators.pattern('^[A-Za-z0-9]+$')]),
      age: this.fb.control(null, [Validators.required, Validators.pattern('^[0-9]+$'), Validators.min(23)]),
      displayName: this.fb.control(null, [Validators.required, Validators.pattern('[^0-9]+$')]),
      dob: this.fb.control(null),
      email: this.fb.control(null, [Validators.required, Validators.email]),
      workPhone: this.fb.control(null, [Validators.pattern('^[0-9-]+$'), Validators.maxLength(15)]),
      mobile: this.fb.control(null, [Validators.required, Validators.pattern('^[0-9]+$'), Validators.maxLength(10), Validators.minLength(10)]),
      altMobile: this.fb.control(null, [Validators.pattern('^[0-9]+$'), Validators.maxLength(10), Validators.minLength(10)]),
      address: this.fb.control(null),
      streetName: this.fb.control(null),
      city: this.fb.control(null, [Validators.required, Validators.pattern('[a-zA-Z- ]*')]),
      districtId: this.fb.control(null, [Validators.required]),
      stateId: this.fb.control(null, [Validators.required]),
      countryId: this.fb.control(null, [Validators.required]),
      pincode: this.fb.control(null, [Validators.required, Validators.pattern('^[0-9]+$'), Validators.maxLength(6), Validators.minLength(6)]),
      //councilNum: this.fb.control(null, [Validators.pattern('^[^\\s]+[a-zA-Z0-9\\s]+[^\\s]$')]),
      panNo: this.fb.control(null, [Validators.maxLength(10),Validators.minLength(10)]),
      //councilId: this.fb.control(null),
      //photo: this.fb.control(null),
      departmentId: this.fb.control(null,[Validators.required]),

      jobType: this.fb.control(null,[Validators.required]),

      doctor: this.fb.control(this.valueSet),
      lastName: this.fb.control(null, [ Validators.pattern('[^0-9]+$')]),
     
    }, { validators: mobileAndAltMobileValidator("mobile", "altMobile") });
 
  }
onAgeChge(event) {
  //debugger
    let date: Date = this.dateService.addDay(new Date((this.dateService.getYear(this.dateService.today()) - event.target.value), 0, 1), 0)
    this.physicianForm.controls["dob"].setValue('');
  }
loadNewPhysicianList():void {
  //debugger;
   this.phySrvc.newlist(`physicians/${this.tenandId}/${this.branchId}/list`).pipe(takeUntil(this.unsubscribe$)).subscribe((data:any)=>{
     console.log("Data = ", data);     
     this.data =data;
   },
   (error)=>{

   },
   ()=>{
   });
  }

  ngOnInit(): void {
    this.loadNewPhysicianList();
    this.physicianForm.controls["name"].valueChanges.subscribe((value: string) => {
      this.physicianForm.controls["displayName"].setValue(value);
    });
    this.physicianForm.controls["dob"].valueChanges.subscribe((value: string) => {
      if(value !== null && value !== undefined && value !== "")
        this.rangeChangeEmitter(value);
    });
    this.max = this.dateService.addDay(new Date((this.dateService.getYear(this.dateService.today())-23),12,31), 0);
    this.isAddComponnet = false;
    this.isEditComponnet = false;
    this.loadGeo();
    this.loadCouncil();
    this.loadDept();

    this.loadAccreditations();
    this.loadQualifications(); 


    this.fromPageNameReferralSettings="Physician";
  }
  getTenantPackageId() {

    this.tenantpackageSrvc.tenantList(`tenantPackage/GetTenantBranchDuplicate/${this.tenandId}/${this.branchId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((tenPackage: any) => {

      this.tenantPackageId= tenPackage[0].packageId;

    }, (error) => {

    }, () => {

    });

}
onCancel()
{
  this.diaClose.emit(null);
  //this.router.navigate(['auth/patient-login']);
}
 
  openReferralSettings(){
    this.referralSettings=true;
    //this.closeMyPopup=false;
  }
  closeComponent(){
    this.referralSettings=false;
  }
  
  get fval() { return this.physicianForm.controls; }

  getItems(args: any){
    
    let temp = this.items.slice(0);
    temp.forEach(x=>{
      x.title=args.name});
    return temp;
  }

  trim (el, arg) {
    el = el.replace (/\s{2,}/g,' ')
  
    console.log(el);   
    this.physicianForm.controls[arg].setValue(el.trim());
}

capitalize = (s,arg) => {
 // if (typeof s !== 'string') return ''
 // return s.charAt(0).toUpperCase() + s.slice(1)
 s=s.charAt(0).toUpperCase()+ s.slice(1);
s = s.replace (/\s{2,}/g,' ');

 this.physicianForm.controls[arg].setValue(s.trim());
}
dashtoTitleCase(s,arg) {
  // s = s.replace (/\s/g,'')
   var array = s.split("-"); //console.log(array);
   
 var result = array.map(current => {
  
     return current[0].toUpperCase() + current.substr(1);
 });
 //result = result.replace (/\s/g,' ')
 var end = result.join("-");
 
  this.physicianForm.controls[arg].setValue(end);  
 }
 


  

  // *************


  loadAccreditations(): void {
 
    this.accredtnSrvc.list().pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.accreditationList = data.value;

     
    }, (error) => {

    }, () => {

    });
  }

  loadQualifications(): void {
    
    this.qualifnSrvc.list().pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.qualificationsList = data.value;

      
    }, (error) => {

    }, () => {

    });
  }

 


  //***************



  loadGeo(): void {
    this.cntrySrvc.list().pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.countriesList = data.value;
      this.stateSrvc.list().pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.statesList = data.value;
        this.loadstatesList = data.value;
        this.districtSrvc.list().pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
          this.districtsList = data;
          this.loadDistrictsList = this.districtsList;

        }, (error) => {

        }, () => {

        });

      }, (error) => {

      }, () => {

      });
    }, (error) => {

    }, () => {

    });
  }
  loadCouncil(): void {
    this.councilSrvc.list().pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.councilList = data.value;
    }, (error) => {
    }, () => {

    });
  }

  loadDept(): void {
    this.deptSrvc.list(this.tenandId + '/' + "departments").pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.deptList = data.value;
    }, (error) => {
    }, () => {
    });
  }

  imgUpload(files: File[]): void {
    this.imgFile = files[0];
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
    }
  }

  onDistrictChge(event: INgxSelectOption[]): void {
    if (event != null && event.length > 0) {
    this.physicianForm.controls["countryId"].setValue(event[0].data.countryId);
    this.physicianForm.controls["stateId"].setValue(event[0].data.stateId);
    }
    else {
      return;
    }
  }

  onCountryChge(event: string): void {
    if (this.statesList != null && this.statesList != undefined && this.statesList.length > 0) {
      if (event != null) {
        this.physicianForm.controls["stateId"].setValue(null);
        this.loadstatesList = this.statesList.filter(x => x.countryId == event);
      }
      else {
        this.loadstatesList = this.statesList.slice();
      }
    }
    else {
      return;
    }
  }

  onStateChge(event: string): void {
    if (this.districtsList != null && this.districtsList != undefined && this.districtsList.length > 0) {
      if (event != null) {
        this.physicianForm.controls["districtId"].setValue(null);
        this.loadDistrictsList = this.districtsList.filter(x => x.stateId == event);
      }
      else {
        this.loadDistrictsList = this.districtsList.slice();
      }
    }
    else {
      return;
    }
  }

  callAdd(): void {
    this.physicianForm.reset();

    this.isAddComponnet = true;
    this.isEditComponnet = false;
  }
  onClear(): void {
    this.physicianForm.reset();
    this.isAddComponnet = false;
    this.isEditComponnet = false;
    this.isSubmitted = false;
    this.isBtnSubmitted = false;
  }
  refreshEmployee(event)
  {
    console.log("event",event);
    this.doctorQualification=event?.data;   
    this.sendOtp();
  }
  onOtpDiaClose(event){
    console.log("Ev = ", event);
    if(event==null){
    this.onCancel();
    }else{
      if(event.otpStatus=="approved"){
        this.onSave();
      }else{
        // this.onCancel();
      }
    }
    
  }
  onReset(): void {
    this.physicianForm.reset();
    this.isSubmitted = false;
    this.isBtnSubmitted = false;
  }
  openPhysicianSettings()
  {
    this.router.navigate(['/pages/masters/physician-settings/', this.physicianId]);

  }

  onDoctorQualificationSave(): void {
    
    if (this.doctorQualification.length>0) {
      var data=this.doctorQualification;
     console.log("phyician ID",this.physicianId);     
      this.phyqualificationSrvc.create("physicianqualification/" + this.tenandId + '/' + this.branchId  + '/' + this.physicianId , data).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        
        console.log("Data Qualification = ", data);
        this.isconfirmation=true;
        setTimeout(() => {
          this.isconfirmation = false;
          this.onCancel();
        }, 2000);

      }, (error) => {
        this.isSubmitted = false;
        this.isBtnSubmitted = false;
      }, () => {
        this.isSubmitted = false;
        this.isBtnSubmitted = false; 
 
      // this.onCancel();

      });
    }
    else
    {
      this.isBtnSubmitted = false;
   return ; 
    }
  }
  
  // callEdit(data: Physician): void {
  //   this.isEditComponnet = true;
  //   this.isAddComponnet = false;

  //   this.physicianId = data.id;

  //   this.editPhyDetails = data;



  //   this.editPhyDetails = data;
  //   this.physicianForm.controls['email'].setValue(data.email);
  //  // this.physicianForm.controls['globalId'].setValue(data.globalId);
  //   this.physicianForm.controls['name'].setValue(data.name);
  //   this.physicianForm.controls['displayName'].setValue(data.displayName);
  //  this.doctorName='Dr'+' '+ data.displayName;
  //   this.physicianForm.controls['lastName'].setValue(data.lastName);
  //   this.physicianForm.controls['dob'].setValue(data.dob);
  //  // this.physicianForm.controls['dob'].setValue(new Date(this.datePipe.transform(data.dob, 'mediumDate')));
  //   this.physicianForm.controls['workPhone'].setValue(data.workPhone);
  //   this.physicianForm.controls['mobile'].setValue(data.mobile);
  //   this.physicianForm.controls['altMobile'].setValue(data.altMobile);
  //   this.physicianForm.controls['age'].setValue(data.age);
  //   this.physicianForm.controls['streetName'].setValue(data.streetName);

  //   this.physicianForm.controls['city'].setValue(data.city);
  //   this.physicianForm.controls['countryId'].setValue(data.countryId);
  //   this.physicianForm.controls['stateId'].setValue(data.stateId);
  //   this.physicianForm.controls['districtId'].setValue(data.districtId);
  //   this.physicianForm.controls['pincode'].setValue(data.pincode);
  //   this.physicianForm.controls['address'].setValue(data.address);
  //   //this.physicianForm.controls['accreditation'].setValue(data.accreditation);
  //   //this.physicianForm.controls['accreditation_Dtl'].setValue(data.accreditation_Dtl);
  //   this.physicianForm.controls['departmentId'].setValue(data.departmentId);
  //   this.physicianForm.controls['panNo'].setValue(data.panNo);
  //   this.physicianForm.controls['gender'].setValue(data.gender);

  //   this.physicianForm.controls['jobType'].setValue(data.jobType);

  //   this.iatchSrvc.getById(`${environment.apiUrl}/ImageAtchDet/${this.tenandId}/${this.branchId}/all`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

  //     //console.log(data.id)
  //     //debugger
  //     this.x =  data.filter(x=>x.phyId===this.editPhyDetails.id)
  //     console.log(this.x)
  //     //
  //     this.srcname="../.././../../assets/images/userav.png"
  //     if(this.x.length>0)
  //     {
  //       this.x[0].isCreate = this.isCreate;
  //       this.x[0].isEdit = this.isEdit;
  //     this.iatchSrvc.create(`${environment.apiUrl}/ImageAtchDet/${this.tenandId}/${this.branchId}/download`,this.x[0]).pipe(takeUntil(this.unsubscribe$)).subscribe((downloaddata: any) => {

  //       //console.log(downloaddata)
  //       this.srcname = 'data:image/jpeg;base64,' + downloaddata;
  //      // const reader = new FileReader();
  //       //reader.onload = e => this.srcname = reader.result;

  //       //reader.readAsDataURL(downloaddata);

  //     }, (error) => {

  //     }, () => {

  //     });
  //   }
  // }, (error) => {

  // }, () => {

  // });

  // }

  sendOtp() {
    if(true)
    {
     var mobileNumber =this.physicianForm.value.mobile;
    this.patRegSrvc.sendMessageOtp("communication/" + environment.patientTenantId + '/' + environment.patientTenantId + '/sendotp/' + mobileNumber,this.smsdto).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      
      this.otpId = data;
      console.log("sendmessage...........", data); 

    }, (error) => {
     

    }, () => {
     // console.log("otp sent...........", this.isOtpDia);
       this.stepperComponentInstance.next();
      // this.isCustomerExist =false;

      // this.isOtpDia = true;
       this.otpVerifyInstance.fromPatientPortal(mobileNumber,environment.patientTenantId,this.otpId, "PatientPortal")
      this.cd.detectChanges();

      console.log("otp sent..ggg.........", this.otpVerifyInstance);
    });
   }
  }

  save(args: { [key: string]: boolean | NbTabComponent }): void {
   
       console.log("Save fun call");      
        // this.onSave(args);   
        if (this.physicianForm.valid) {
          var id=0;
          for(var i=0;i<this.data.length;i++){
            if(this.data[i].email==this.physicianForm.value.mobile || this.data[i].mobile==this.physicianForm.value.mobile){
              id++;
            }
          }
          if(id==0)
          {
            this.stepperComponentInstance.next();
          }else{
            this.isAlreadyRegistered = true;  
            setTimeout(() => {
              this.isAlreadyRegistered = false;
              // this.onCancel();
            }, 2000);
          }
        }else{
          this.iserror=true;
          setTimeout(() => {
            this.iserror = false;
            // this.onCancel();
          }, 2000);
  
        }
   
  }
  back(){
    this.stepperComponentInstance.previous();
  }
     

  onSave(): void {
    console.log("Save = ");
    
    let today :any;
    today= new Date().toLocaleString();
    this.isSubmitted = true;
    this.isBtnSubmitted = true;
    if (this.physicianForm.valid) {
      console.log("insert ",this.physicianForm.value);
      this.newPhyData = this.physicianForm.getRawValue();
      this.newPhyData.tenantId = this.tenandId;
      this.newPhyData.branchId = this.branchId;
      this.newPhyData.doctor=this.valueSet;
      this.newPhyData.createdDate=today ;
      this.phySrvc.create("physicians/" + this.tenandId + '/' + this.branchId, this.newPhyData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        console.log("Save = ", data);        
        this.data = data.value;
        this.physicianId = data.id;
        this.onDoctorQualificationSave();
        // window.localStorage.setItem("phyID",this.physicianId)
        if(this.fileToUpload!=null)
        {
          const formData: FormData = new FormData();
        formData.set('fileKey', this.fileToUpload, data.id+"."+this.fileToUpload.name.substring(this.fileToUpload.name.lastIndexOf('.') + 1));
        //console.log(formData);
        let postData: imageatch_det= {
          tenantId: this.tenandId,
          branchId: this.branchId,
          containerName: this.tenandId,
          fileLocation: `${this.tenandId}/${this.branchId}/physician/${data.id+"."+this.fileToUpload.name.substring(this.fileToUpload.name.lastIndexOf('.') + 1)}`,
          fileName: data.id+"."+this.fileToUpload.name.substring(this.fileToUpload.name.lastIndexOf('.') + 1),
          category: "physician",
          createdDate: new Date(),
          createdBy: localStorage.getItem("userId"),
          phyId:data.id,
          isCreate:this.isCreate,
          isEdit:this.isEdit,
          isView:this.isView,
          
        }
        
        for (const prop in postData) {
          if (!postData.hasOwnProperty(prop)) { continue; }
          formData.append(prop , postData[prop]);
        }
    
        this.iatchSrvc.create(`${environment.apiUrl}/ImageAtchDet/${this.tenandId}/${this.branchId}/atch`,formData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
       // this.loadFileData();
        // this.tenantEditForm.controls["file"].setValue("");
        this.myInputVariable.nativeElement.value = "";
         
        }, (error) => {
         // this.isBtnSubmitted = false;
        }, () => {
         // this.onClear();
  
        });
      }

      }, (error) => {
        console.log(error);
        
        this.isSubmitted = false;
        this.isBtnSubmitted = false;
        if(error.status == 409)
        {
          this.isAlreadyRegistered = true;
        }
      }, () => {
       
         
          this.physicianForm.reset();
          // this.loadNewPhysicianList();
          this.imgFile = null;
          this.isAddComponnet = false;
         // this.fetchPhysician();
          this.isSubmitted = false;
          this.isBtnSubmitted = false;
       
      //  this.fetchPhysician();
    

      });
    }
    else
    {
      console.log("False ",this.physicianForm.value);
      this.isBtnSubmitted = false;
      return;
    }
    // this.stepperComponentInstance.next();
  }

  getCountryName(id: any): string {
    if (id != null && id != "" && this.countriesList != undefined && this.countriesList.length > 0)
      return ((this.countriesList).find(x => x.id == id).name);
    else
      return "";
  }

  getStateName(id: any): string {
    if (id != null && id != "" && this.statesList != undefined && this.statesList.length > 0)
      return ((this.statesList).find(x => x.id == id).name);
    else
      return "";
  }

  getDistrictName(id: any): string {
    if (id != null && id != "" && this.districtsList != undefined && this.districtsList.length > 0)
      return this.districtsList.find(x => x.id == id).name;
    else
      return "";
  }

  getCouncilName(id: any): string {

    if (id != null && id != "" && this.councilList != undefined && this.councilList.length > 0)
      return this.councilList.find(x => x.id == id).name;
    else
      return "";
  }

  getDeptName(id: any): string {
    if(this.deptList != null && this.deptList != undefined && this.deptList.length > 0)
    {
    if (id != null && id != "")
      return this.deptList.find(x => x.id == id).name;
    else
      return "";
    }
    else
      return "";
  }

  
//**********
QualificationsName(id: any): string {

  if (id != null && id != "" && this.qualificationsList != undefined && this.qualificationsList.length > 0)
    return this.qualificationsList.find(x => x.id == id).name;
  else
    return "";
}

AccreditationName(id: any): string {

  if (id != null && id != "" && this.accreditationList != undefined && this.accreditationList.length > 0)
    return this.accreditationList.find(x => x.id == id).name;
  else
    return "";
}
 
  rangeChangeEmitter(event: any): void {
    if(event!="" && event!=null && event!=undefined){

    var Difference_In_Time = Math.abs(Date.now() - event.getTime());
    var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
    var ageValue = Difference_In_Days / 365.25;
    this.physicianForm.controls['age'].setValue(Math.round(ageValue));
  }
}
  onSearch() {
  
   if(this.term == "" || this.term == undefined)
   
     this.term=null;
    let searchData = {
      searchWord: this.term,
      skip:0,
      take:50

    }
    this.phySrvc.searchList("physicians/" + this.tenandId + '/' + this.branchId + '/search', searchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      console.log("...........search.............", data);
      this.data = data; 
    },error=>{
      console.log("error = ", error);
      
    });
  }
  prevclicked()
  {
    console.log(this.p)
    if(this.p>1)
    this.p= this.p - 1
  }
  nextclicked()
  {
   console.log(this.p)
   console.log(this.data.length/10)
   if(this.p < (this.data.length/10))
   {
     this.p = this.p + 1
     console.log("P incremented")
   }
   else
    {
      //console.log(this.p)
    
 if(this.term == "" || this.term == undefined)
 {
   
   this.term=null
 }
     this.skip=this.skip+100;
     //this.take=this.take+100
     let searchData = {
      searchWord: this.term,
      skip:this.skip,
      take:this.take

    }
    this.phySrvc.searchList("physicians/" + this.tenandId + '/' + this.branchId + '/search', searchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      console.log("...........search.............", data);
      this.data = data;
      //  this.data = this.fullData.filter(x => {
      //    let tempregDate: Date = new Date(x.regDate);
      //    return this.dateService.compareDates(new Date(tempregDate.setHours(0, 0, 0, 0)), new Date(this.dateService.today().setHours(0, 0, 0, 0))) == 0;

      //  });

    });
 
    
   }
 
   
 
  }
  handleFileInput(files: any) {
   
    if(this.isCreate || this.isEdit)
    {
      this.fileset=true;
    if(files.currentTarget.files.length>0)
    {
   
    this.fileToUpload = files.currentTarget.files[0]
    
   const file = files.target.files[0];

        const reader = new FileReader();
        reader.onload = e => this.srcname = reader.result;

        reader.readAsDataURL(file);
    }
    //console.log(this.fileToUpload.name.substring(this.fileToUpload.name.lastIndexOf('.') + 1));
    
  }
  else
{
  this.fileset=false;
}
}

 

}

export function mobileAndAltMobileValidator(mobile: string, altMobile: string): ValidationErrors | null {
  return (group: FormGroup) => {
    let mobileInput = group.controls[mobile];
    let altMobileInput = group.controls[altMobile];
    if (mobileInput.value === altMobileInput.value && altMobileInput.value !=="" && altMobileInput.value !== undefined && altMobileInput.value !== null) {
      return { equivalent: true }
    }
    else {
      return null
    }
  }
}

